import { defineComponent as _defineComponent } from 'vue'
import { User } from '@/interfaces/vuex/user';
import store from '@/store';
import { readAssertedUserProfile } from '@/store/main/getters';
import { computed, reactive, ref, watch } from 'vue';
import { RoleId } from '@/lib/enum';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import CompanyUserForm from '@/views/pages/companyUsers/CompanyUserForm.vue';
import { CompanyUserFormData, useUserComposable } from '@/composables/useUser';
import {
  Department,
  DepartmentTreeNode,
} from '@/interfaces/model/general/department';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserUpdateDialog',
  props: {
    value: { type: Boolean },
    user: null,
    selectableDepartments: null,
    departmentTree: null
  },
  emits: ["input", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'updated'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user?: User;
  selectableDepartments: Department[];
  departmentTree: DepartmentTreeNode[];
};

const m = defineMessages({
  userInformationChange: 'ユーザー情報を変更',
});

const { updateUser } = useUserComposable();




const isMe = computed(() => {
  return readAssertedUserProfile(store).uuid === props.user?.uuid;
});
const localValue = ref(props.value);
const isValidForm = ref(false);
const isLoading = ref(false);
const formRef = ref();
const userForm = reactive<CompanyUserFormData>({
  firstName: '',
  lastName: '',
  middleName: '',
  email: '',
  departments: [],
  position: '',
  phone: '',
  isSubscribe: true,
  roleId: RoleId.USER_VIEWER.value,
});

const resetForm = () => {
  userForm.firstName = '';
  userForm.lastName = '';
  userForm.middleName = '';
  userForm.email = '';
  userForm.departments = [];
  userForm.position = '';
  userForm.phone = '';
  userForm.isSubscribe = true;
  userForm.roleId = RoleId.USER_VIEWER.value;
};

const closeDialog = () => {
  if (isLoading.value) {
    return;
  }
  resetForm();
  formRef.value.resetValidation();
  localValue.value = false;
  emits('input', false);
};

const handleUpdateClick = async () => {
  formRef.value.validate();
  if (!isValidForm.value) {
    return;
  }
  try {
    isLoading.value = true;
    await updateUser(props.user?.uuid || '', {
      firstName: userForm.firstName,
      lastName: userForm.lastName,
      middleName: userForm.middleName,
      position: userForm.position,
      phone: userForm.phone,
      isSubscribe: userForm.isSubscribe,
      departments: userForm.departments,
      roleId: userForm.roleId,
    });
    isLoading.value = false;
    closeDialog();
    emits('updated');
  } catch (e) {
    isLoading.value = false;
  }
};

const handleCancelClick = () => {
  closeDialog();
};

const updateUserForm = (updatedForm: CompanyUserFormData) => {
  Object.assign(userForm, updatedForm);
};

watch(
  () => props.user,
  (newValue) => {
    if (!newValue) {
      resetForm();
      return;
    }
    userForm.firstName = newValue.first_name;
    userForm.lastName = newValue.last_name;
    userForm.middleName = newValue.middle_name;
    userForm.email = newValue.email;
    userForm.departments = newValue.departments;
    userForm.position = newValue.position;
    userForm.isSubscribe = newValue.is_subscribe;
    userForm.phone = newValue.phone;
    userForm.roleId = newValue.role_id;
  }
);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

return { __sfc: true,m, updateUser, props, emits, isMe, localValue, isValidForm, isLoading, formRef, userForm, resetForm, closeDialog, handleUpdateClick, handleCancelClick, updateUserForm, BaseFormCard, CompanyUserForm, sharedMessages }
}

})